import { render, staticRenderFns } from "./dismantle-modal.vue?vue&type=template&id=0356ccb8&scoped=true"
import script from "./dismantle-modal.vue?vue&type=script&lang=js"
export * from "./dismantle-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356ccb8",
  null
  
)

export default component.exports